import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';

const DepartmentForm = ({ department, departments, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState(department || {
    name: '',
    code: '',
    parent_id: '',
    status: 'active'
  });

  useEffect(() => {
    if (department) {
      setFormData({
        ...department,
        parent_id: department.parent_id || ''
      });
    } else {
      setFormData({
        name: '',
        code: '',
        parent_id: '',
        status: 'active'
      });
    }
  }, [department]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };
  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">{department ? 'Edit' : 'Add'} Department</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Code*</Form.Label>
                <Form.Control
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Parent Department</Form.Label>
                <Form.Select
                  name="parent_id"
                  value={formData.parent_id}
                  onChange={handleChange}
                  style={{ fontSize: '0.8rem' }}
                >
                  <option value="">None</option>
                  {departments.map(dept => (
                    <option key={dept.id} value={dept.id}>
                      {dept.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  style={{ fontSize: '0.8rem' }}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {department ? 'Update' : 'Create'} Department
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default DepartmentForm;